import { ChatStates, selectChatState } from '@vh/slices/chat/ChatSlice';
import { usePrevious } from '@vh/utility/StateHooks';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

// FOR SCORM
export const useDispatchSessionCompleteIframeEvent = () => {
  const chatState = useSelector(selectChatState);
  const prevChatState = usePrevious(chatState);
  
  useEffect(() => {
    if (chatState === ChatStates.COMPLETE && prevChatState !== chatState) {
      var event = new CustomEvent('onVHSessionComplete');
      // in iframe, so call parent document's dispatch
      window.parent.document.dispatchEvent(event);
    }
  }, [chatState, prevChatState]);
};
